import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import Triangle from './Triangle';

const TriangleIcon = props => (
    <IconFromPath {...props} Path={Triangle} />
);

export default TriangleIcon;
